import {
  takeEvery,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';
import {
  searchSuccess,
  searchFail,
  hotelSearchRequest,
  initHotelSearchRequest,
  setHotelTripSearchParam,
  pollingHotelSearchRequest,
} from '../../slices/tripSearch';
import formatRoomsRequest from '../../../helpers/formatRoomsRequest';
import { ListPageSize, TravelTypes } from '../../../constants';
import { changeTrip } from '../../slices/trip';
import getHotelPriceDisplayPreference from '../../../helpers/selectors/getHotelPriceDisplayPreference';
import { setIsUserInteractedWithHotelList } from '../../slices/hotel';

const queryString = require('query-string');

function* hotelTripSearchWorker(action) {
  try {
    const hotelRateCodes = yield select((store) => store.user.hotelRateCodes);
    const searchObjOld = yield select((store) => store.tripSearch.searchObj.hotel);
    const { ignoreCachedResultsForModes } = yield select((store) => store.trip);
    const { currencyCode, requestId } = yield select((store) => store.tripSearch);
    const rateDisplayPreference = yield select(getHotelPriceDisplayPreference(true));

    const { hasUserInteractedWithHotelList } = yield select((store) => store.hotel);
    let rateCodes = (action.payload && action.payload.rateCodes)
      || (searchObjOld && searchObjOld.rateCodes);
    if (hotelRateCodes && hotelRateCodes.length && !rateCodes) {
      rateCodes = _.map(_.filter(hotelRateCodes, (r) => r.isSelectedByDefault), 'rateCode');
      if (rateCodes.length === 0) rateCodes = undefined;
    }

    yield put(setHotelTripSearchParam({
      ...{
        ...action.payload,
        rateCodes,
      },
    }));
    const {
      checkInDate, checkOutDate, filterRating, selectedAddress, page, pageSize,
      sortBy, sortDirection, exactMatchRateCodesOnly, doShowOnlyAgentPreferredHotels,
      doShowAvailableHotelsOnly,
      filterAmenities, filterHotelChains, filterHotelKeys,
      fromPrice, toPrice, doShowCommissionableRatesOnly, showRefundableHotelRatesOnly,
      hotelProvidersToInclude, searchRadiuses,
    } = yield select((store) => store.tripSearch.searchObj.hotel);
    const { staterooms } = yield select((store) => store.tripSearch.searchObj);

    const query = {
      checkInDate,
      checkOutDate,
      filterRating,
      page,
      pageSize,
      sortBy,
      sortDirection,
      placeId: selectedAddress && !selectedAddress.hotelId ? selectedAddress.value : undefined,
      latitude: selectedAddress && selectedAddress.hotelId ? selectedAddress.lat : undefined,
      longitude: selectedAddress && selectedAddress.hotelId ? selectedAddress.lon : undefined,
      rateCodes,
      exactMatchRateCodesOnly,
      doShowOnlyAgentPreferredHotels,
      doShowAvailableHotelsOnly,
      filterHotelChains: filterHotelChains || [],
      filterHotelKeys: filterHotelKeys
        ? filterHotelKeys.map((item) => item.value)
        : [],
      filterAmenities: filterAmenities
        ? filterAmenities.map((item) => item.value) : [],
      ...formatRoomsRequest(staterooms),
      doReturnTravelOptions: true,
      doReturnHotelPins: true,
      preferredHotelId: selectedAddress && selectedAddress.hotelId,
      doGetRemainingHotelsOnly: action.payload && action.payload.doGetRemainingHotelsOnly,
      fromPrice,
      toPrice,
      doIgnoreCachedResults: ignoreCachedResultsForModes && ignoreCachedResultsForModes.length
        && ignoreCachedResultsForModes.indexOf(TravelTypes.hotel) > -1
        ? true : undefined,
      rateDisplayPreference,
      currencyCode: currencyCode || undefined,
      doGetCommissionableRatesOnly: doShowCommissionableRatesOnly,
      showRefundableHotelRatesOnly,
      requestId,
      doConsiderMarkupRate: true,
      hotelProvidersToInclude,
      searchRadiuses,
    };

    if (action.payload && action.payload.hasFilterApplied) {
      query.doMergeCached = true;
      yield put(setIsUserInteractedWithHotelList(false));
    } else if (hasUserInteractedWithHotelList) query.doMergeCached = false;
    if (query.doIgnoreCachedResults) yield put(changeTrip({ field: 'ignoreCachedResultsForModes', value: _.reject(ignoreCachedResultsForModes, (ss) => ss === TravelTypes.hotel) }));

    const qs = queryString.stringify(query, { skipNull: true });
    const url = `/hotels/search?${qs}`;
    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data && data.doHaveMoreHotels
      && !(action.payload || {}).doIgnoreStoredResults
      && action.payload && pageSize === ListPageSize) {
      // Call hotel search to get remaining hotels only
      yield put(pollingHotelSearchRequest({
        doGetRemainingHotelsOnly: true,
        searchProgress: 10,
        requestId,
      }));
    } if (action.payload && action.payload.doGetRemainingHotelsOnly) {
      // Hide hotel search progressbar
      yield put(setHotelTripSearchParam({
        searchProgress: undefined,
      }));
    }
    if (!action.payload || !action.payload.doGetRemainingHotelsOnly) {
      yield put(searchSuccess(data));
    }
  } catch (error) {
    console.log(error);
    yield put(searchFail('Network error'));
  }
}

function* hotelTripSearchWatcher() {
  yield takeEvery(hotelSearchRequest.toString(), hotelTripSearchWorker);
  yield takeLatest(initHotelSearchRequest.toString(), hotelTripSearchWorker);
  yield takeLatest(pollingHotelSearchRequest.toString(), hotelTripSearchWorker);
}

export default hotelTripSearchWatcher;
